// Jewelry module — sidebar / navigation French strings
export const frNav: Record<string, string> = {
  'Vault Inventory': 'Inventaire du Coffre-fort',
  'Gemstone Certificates': 'Certificats de Pierres Précieuses',
  'Metal Spot Rates': 'Cours des Métaux Précieux',
  'Trade-In & Scrap Buyback': 'Reprise & Rachat d\'Or',
  'VAULT & INVENTORY': 'COFFRE-FORT & INVENTAIRE',
  'PRECIOUS METALS': 'MÉTAUX PRÉCIEUX',
  'CUSTOMERS': 'CLIENTS',
  'Point of Sale': 'Point de Vente',
  'Sales History': 'Historique des Ventes',
  'Suppliers': 'Fournisseurs',
  'Customers': 'Clients',
  'Reports': 'Rapports',
  'Audit Logs': 'Journaux d\'Audit',
  'SALES & POS': 'VENTES & CAISSE',
  'ANALYTICS & REPORTS': 'ANALYSES & RAPPORTS',
  'OVERVIEW': 'APERÇU',
};
